
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4232"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4232"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jHPLc", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $e58a2efd6c2b31d6$export$6503ec6e8aabbaf; }, function (v) { return $e58a2efd6c2b31d6$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $e58a2efd6c2b31d6$export$f7ad0328861e2f03; }, function (v) { return $e58a2efd6c2b31d6$export$f7ad0328861e2f03 = v; });
var $e58a2efd6c2b31d6$export$6503ec6e8aabbaf;
var $e58a2efd6c2b31d6$export$f7ad0328861e2f03;
"use strict";
var $e58a2efd6c2b31d6$var$mapping = new Map();
function $e58a2efd6c2b31d6$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$e58a2efd6c2b31d6$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $e58a2efd6c2b31d6$var$resolve(id) {
    var resolved = $e58a2efd6c2b31d6$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$e58a2efd6c2b31d6$export$6503ec6e8aabbaf = $e58a2efd6c2b31d6$var$register;
$e58a2efd6c2b31d6$export$f7ad0328861e2f03 = $e58a2efd6c2b31d6$var$resolve;

});

var $fee7f0f6cf5f8742$exports = {};

(parcelRequire("jHPLc")).register(new URL("", import.meta.url).toString(), JSON.parse('["2lyl3","index.aa6d4633.js","9Jo43","phone-frame.b86bc4f5.svg","gCsL5","app.d3163006.png","4nfgJ","logo.2ea790a4.svg","2yL3M","logo-rtl.1b37b5a5.svg","4gn5H","import.3c8459d8.png","8by16","shoppingList.3e3fef12.png","cZErs","steps.8557b918.png","4L2KN","web-vitals.22ff2d33.js"]'));


//# sourceMappingURL=index.runtime.827df37d.js.map
